import React, { useEffect } from 'react';
import { GrowlNotification } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useAccount, useMsal } from '@azure/msal-react';
import { LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

import { selectAllLocales, selectCurrentLocale, setLocale } from '../../../store/locales';
import { selectNotification, resetNotification } from '../../../store/ui';
import Navigation, { MainSiteNavigationComponentId } from '../../../shared/telia-react-component-library/Navigation/Navigation';

export const getMainSiteNavigationComponentHeight = () => {
  const nav = document.getElementById(MainSiteNavigationComponentId) as HTMLElement;
  return nav?.offsetHeight || 0;
};

export default function Header() {
  const { t } = useTranslation('header');

  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  const locales = useSelector(selectAllLocales);
  const currentLocale = useSelector(selectCurrentLocale);
  const notification = useSelector(selectNotification);

  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleLocaleChange = (locale: LocaleResponse) => {
    dispatch(setLocale(Number(locale.id)));
  };

  useEffect(
    () =>
      history.listen(() => {
        dispatch(resetNotification());
      }),
    [dispatch, history],
  );

  return (
    <>
      {notification.show && (
        <GrowlNotification
          notification={notification.text}
          variant={notification.type}
          closeOnClick={() => {
            dispatch(resetNotification());
          }}
        />
      )}

      <Navigation
        logo={{ link: '/', linkAriaLabel: '' }}
        languages={locales.map(locale => ({
          text: locale.language_tag.split('-')[1],
          onClick: () => handleLocaleChange(locale),
          active: locale.id === currentLocale?.id,
        }))}
        login={{
          headingText: '',
          tabs: [],
          onLogout: () => void instance.logout(),
        }}
        userMenu={{
          username: account?.name || '',
          userInitials: account?.username?.charAt(0) || '',
          userMenuLinks: [],
          logoutButtonLabel: t('userMenu.logoutButtonLabel'),
        }}
        menuItems={[
          {
            text: t('menuItems.products'),
            url: '/',
            active: !!(pathname === '/' || pathname.match(/^\/product/)),
          },
          {
            text: t('menuItems.bundles'),
            url: '/bundles',
            active: !!pathname.match(/^\/bundle/),
          },
          {
            text: t('menuItems.salesChannels'),
            // TODO: change to sales-channels
            url: '/saleschannels',
            active: !!pathname.match(/^\/saleschannel/),
          },
          {
            text: t('menuItems.adminSettings'),
            url: '/adminsettings',
            active: pathname === '/adminsettings',
          },
        ]}
      />
    </>
  );
}
